import { defineStore } from "pinia";

// Позволяет любому компоненту открыть форму фидбека, не владея своим
// экземпляром диалога - FeedbackDialog.vue монтируется один раз в App.vue
// и следит за `isOpen`. `source` фиксирует, откуда открыта форма, и уходит на бэкенд для админов.
export const useFeedbackStore = defineStore("feedback", {
  state: () => ({
    isOpen: false,
    source: "",
  }),
  actions: {
    open(source: string) {
      this.source = source;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
  },
});
